import { createFileRoute } from "@tanstack/react-router";
import WeekView from "@/components/operations/work-orders/calendar/week-view";

export const Route = createFileRoute(
  "/_authenticated/operations/work-orders/_list/week",
)({
  component: WorkOrdersWeekPage,
});

function WorkOrdersWeekPage() {
  return (
    <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
      <WeekView />
    </div>
  );
}
